import { DeliveryTypeCategory as ApiDeliveryTypeCategory } from '@/features/graphql/generated/graphql'
import { DeliveryTypeCategory as AppApiDeliveryTypeCategory } from '@/features/orders/constants/app'
import invert from 'lodash.invert'

export const apiToAppDeliveryTypeCategory: Record<
    ApiDeliveryTypeCategory,
    AppApiDeliveryTypeCategory
> = {
    [ApiDeliveryTypeCategory.Delivery]: AppApiDeliveryTypeCategory.Delivery,
    [ApiDeliveryTypeCategory.Takeaway]: AppApiDeliveryTypeCategory.Takeaway,
    [ApiDeliveryTypeCategory.EatIn]: AppApiDeliveryTypeCategory.EatIn,
}

export const appToApiDeliveryTypeCategory = invert(apiToAppDeliveryTypeCategory) as Record<
    AppApiDeliveryTypeCategory,
    ApiDeliveryTypeCategory
>
